import { render } from "./PlanDescription.vue?vue&type=template&id=11e32a0d&scoped=true"
import script from "./PlanDescription.vue?vue&type=script&lang=js"
export * from "./PlanDescription.vue?vue&type=script&lang=js"

import "./PlanDescription.vue?vue&type=style&index=0&id=11e32a0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e32a0d"]])

export default __exports__